import styled from "styled-components";
import { Menu, Popover } from "antd";
import { alpha, IconButton } from "@mui/material";
import { primaryColor } from "../styled/Theme";
import { DocumentTextOutline } from "@raresail/react-ionicons";
import {
  URL_AGENT_DEFAULTER_PERFORMANCE_REPORTS,
  URL_AGENT_DEPOSIT_PERFORMANCE_REPORT,
  URL_AGENT_PERFORMANCE_REPORT,
  URL_AGING_REPORT,
  URL_COUPON_SALES_PERFORMANCE_REPORT,
  URL_DAILY_COLLECTION_BALANCES,
  URL_END_OF_DAY_REPORT,
  URL_PARKING_OCCUPANCY_REPORT,
  URL_PAYMENTS_REPORT,
  URL_REVENUE_LEDGER_REPORTS,
  URL_REVENUE_PERFORMANCE,
  URL_REVENUE_SOURCE_PERFORMANCE_REPORT,
  // URL_WAGES_REPORT,
  // URL_WAGE_CALCULATIONS_REPORT,
  // URL_WAGE_ADVANCEMENTS_REPORT,
  // URL_WEEKLY_COLLECTIONS_REPORT,
  // URL_ASSETS_REPORT,
  // URL_ASSET_TRANSFERS_REPORT,
  // URL_ASSET_STATUS_UPDATES_REPORT,
  // URL_ASSET_STOCK_VARIANCE_REPORT,
} from "../../utils/urls";
// import { CAN_VIEW_ASSET_REPORTS } from "../../utils/constants";
// import { useAssetPermissions } from "../../hooks/assets/assetUtils";
import { ActionsMenu } from "../common/FormActions";
import {
  ISAgentUser,
  IsPublicUser,
  IsAccountant,
  IsAdmin,
  IsSuperAdmin,
  IsManager,
  IsHeadOfAccountant,
  // IsSuperUser,
} from "../../utils/permissions";

const ReportsDropdown = () => {
  const isPublicUser = IsPublicUser();
  const isAgent = ISAgentUser();
  const isAccountant = IsAccountant();
  const isAdmin = IsAdmin();
  const isSupperAdmin = IsSuperAdmin();
  const isManager = IsManager();
  // const can = useAssetPermissions();
  // const isSuperUser = IsSuperUser();
  const isHeadOfAccountant = IsHeadOfAccountant();
  // const canViewWageReports =
  // isAdmin || isSuperUser || isHeadOfAccountant || isManager;
  // const canViewAssetReports = can(CAN_VIEW_ASSET_REPORTS);

  const reportSettings: any = [
    {
      label: "Adhoc Reports",
      icon: DocumentTextOutline,
      to: "reports/adhoc",
      visible: true,
    },

    {
      label: "Parking Occupancy Reports",
      icon: DocumentTextOutline,
      to: URL_PARKING_OCCUPANCY_REPORT,
      visible: !isAgent,
    },

    {
      label: "Revenue Performance Report",
      icon: DocumentTextOutline,
      to: URL_REVENUE_PERFORMANCE,
      visible: !isManager,
    },

    {
      label: "End Of Day Report",
      icon: DocumentTextOutline,
      to: URL_END_OF_DAY_REPORT,
      visible: true,
    },
    {
      label: "Daily Collection Balances Report",
      icon: DocumentTextOutline,
      to: URL_DAILY_COLLECTION_BALANCES,
      visible: true,
    },

    {
      label: "Revenue Ledger Reports",
      icon: DocumentTextOutline,
      to: URL_REVENUE_LEDGER_REPORTS,
      visible: true,
    },

    {
      label: "Aging Report",
      icon: DocumentTextOutline,
      to: URL_AGING_REPORT,
      // visible: !isAgent,
    },

    {
      label: "Agent Performance Report",
      icon: DocumentTextOutline,
      to: URL_AGENT_PERFORMANCE_REPORT,
      visible: !isManager,
    },

    {
      label: "Revenue Source Performance Report",
      icon: DocumentTextOutline,
      to: URL_REVENUE_SOURCE_PERFORMANCE_REPORT,
      visible: true,
    },

    {
      label: "Agent Deposits Report",
      icon: DocumentTextOutline,
      to: URL_AGENT_DEPOSIT_PERFORMANCE_REPORT,
      visible: true,
    },

    {
      label: "Agent Defualters Report",
      icon: DocumentTextOutline,
      to: URL_AGENT_DEFAULTER_PERFORMANCE_REPORTS,
      visible: true,
    },

    {
      label: "Coupon Sales Report",
      icon: DocumentTextOutline,
      to: URL_COUPON_SALES_PERFORMANCE_REPORT,
      visible: true,
    },

    {
      label: "Payments Report",
      icon: DocumentTextOutline,
      to: URL_PAYMENTS_REPORT,
      visible: isAccountant || isAdmin || isSupperAdmin || isHeadOfAccountant,
    },
    // {
    // label: "Wages Summary Report",
    // icon: DocumentTextOutline,
    // to: URL_WAGES_REPORT,
    // visible: canViewWageReports,
    // },
    // {
    // label: "Wage Calculations Report",
    // icon: DocumentTextOutline,
    // to: URL_WAGE_CALCULATIONS_REPORT,
    // visible: canViewWageReports,
    // },
    // {
    // label: "Wage Advancements Report",
    // icon: DocumentTextOutline,
    // to: URL_WAGE_ADVANCEMENTS_REPORT,
    // visible: canViewWageReports,
    // },
    // {
    // label: "Weekly Collections Report",
    // icon: DocumentTextOutline,
    // to: URL_WEEKLY_COLLECTIONS_REPORT,
    // visible: canViewWageReports,
    // },
    // {
    // label: "Asset Register Report",
    // icon: DocumentTextOutline,
    // to: URL_ASSETS_REPORT,
    // visible: canViewAssetReports,
    // },
    // {
    // label: "Asset Transfers Report",
    // icon: DocumentTextOutline,
    // to: URL_ASSET_TRANSFERS_REPORT,
    // visible: canViewAssetReports,
    // },
    // {
    // label: "Asset Status Updates Report",
    // icon: DocumentTextOutline,
    // to: URL_ASSET_STATUS_UPDATES_REPORT,
    // visible: canViewAssetReports,
    // },
    // {
    // label: "Asset Stock Variance Report",
    // icon: DocumentTextOutline,
    // to: URL_ASSET_STOCK_VARIANCE_REPORT,
    // visible: canViewAssetReports,
    // },
  ];

  const filteredReportSettings = reportSettings.filter((item) => {
    if (typeof item.visible === "function") {
      return item.visible();
    }
    if (typeof item.visible === "boolean") {
      return item.visible;
    }
    return true;
  });

  return (
    <>
      {!isPublicUser && (
        <Popover
          content={
            <Menu mode="inline" className="font13 rightmenu">
              {ActionsMenu(
                filteredReportSettings.sort((a, b) =>
                  a.label.localeCompare(b.label),
                ),
              )}
            </Menu>
          }
          trigger="click"
          overlayStyle={{ minWidth: 200 }}
          overlayInnerStyle={{ padding: 5 }}
          placement="bottomRight"
        >
          <AvatarWrapper className="animate">
            <IconButton
              sx={{
                bgcolor: alpha(primaryColor, 0.1),
                borderRadius: 10,
                padding: "0.5rem 1rem",
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                color: "#555",
              }}
            >
              <DocumentTextOutline className="font13" />
              <span className="font13">Reports</span>
            </IconButton>
          </AvatarWrapper>
        </Popover>
      )}
    </>
  );
};
export default ReportsDropdown;

export const AvatarWrapper = styled.div`
  &:hover {
    scale: 1.03;
  }
`;
